export const DiscountConditionPopover = () => (
	<div className="discountFilterPopover">
		<b
			style={{
				color: `#3FAF65`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Отличное
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			Устройство имеет минимальные следы эксплуатации и визуально выглядит практически новым.
		</p>
		<br />
		<b
			style={{
				color: `#67BB49`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Хорошее
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			На устройстве присутствуют более значительные следы эксплуатации. Могут быть царапины и потертости на корпусе и
			дисплее
		</p>
		<br />
		<b
			style={{
				color: `#B7BA3A`,
				fontSize: `16px`,
				fontWeight: `500`,
				lineHeight: `22px`,
				marginBottom: `8px`,
				display: `inline-block`
			}}>
			Удовлетворительное
		</b>
		<p style={{ fontSize: `14px`, fontWeight: `400`, lineHeight: `20px`, letterSpacing: `0.28px` }}>
			На устройстве имеются значительные следы эксплуатации. Могут быть потертости, сколы, глубокие царапины на корпусе
			и дисплее
		</p>
	</div>
)
